<!-- eslint-disable max-len -->
<template>
    <nav
        v-scroll="closeOnScroll"
        v-click-outside="(e) => toggleSubMenu()"
        class="header__main-menu main-menu"
        itemscope
        itemtype="http://schema.org/SiteNavigationElement"
    >
        <div
            v-if="activeSubMenu"
            class="main-menu__backdrop"
            @click.self="toggleSubMenu()"
        />
        <ul class="main-menu__list">
            <template v-for="item in getMainItems(getSubItems)">
                <li
                    v-if="item.isActive"
                    :key="item.slug"
                    class="main-menu__list-item submenu"
                    @click="setActiveChapter(item)"
                >
                    <n-link
                        v-if="!item.subMenu && !item.path"
                        :class="[
                            'main-menu__link',
                            {
                                'active-path': isCurrentRoutePath(item.slug),
                            }
                        ]"
                        :to="getLink(item)"
                        itemprop="url"
                    >
                        {{ item.title }}
                    </n-link>
                    <n-link
                        v-else-if="!item.isExternal && item.path && !item.slug"
                        class="main-menu__link"
                        :to="item.path"
                    >
                        {{ item.title }}
                    </n-link>
                    <a
                        v-else
                        :class="[
                            'main-menu__link',
                            {
                                'active-path': isCurrentRoutePath(item.slug) && !activeSubMenu,
                                'open': item.slug === activeSubMenu,
                            }
                        ]"
                        :target="item.isExternal ? '_blank' : '_self'"
                        :href="item.path || '#'"
                        @click.self="onLinkClickHandler($event, item)"
                    >
                        {{ item.title }}
                    </a>
                    <!-- Submenu -->
                    <template v-if="item.subMenu?.length">
                        <div
                            v-show="activeSubMenu === item.slug"
                            class="main-menu__submenu main-menu-submenu"
                        >
                            <div class="wrapper">
                                <div
                                    :class="[
                                        'main-menu-submenu__row',
                                        {'main-menu-submenu__row--big': activeChapter && !activeChapter.services},
                                    ]"
                                >
                                    <!-- Menu list -->
                                    <div
                                        class="main-menu-submenu__col"
                                        @click.self="toggleSubMenu(item.slug)"
                                    >
                                        <span
                                            class="main-menu-submenu__title"
                                            @click="sameLinkEventHandler(getLink(item))"
                                        >
                                            <n-link :to="getLink(item)">
                                                {{ item.title }}
                                            </n-link>
                                        </span>
                                        <template v-for="subitem in item.subMenu">
                                            <template v-if="subitem.isActive">
                                                <span
                                                    v-if="!subitem.isExpanded && !subitem.isExternal"
                                                    :key="subitem.slug"
                                                    class="main-menu-submenu__link"
                                                    @click="sameLinkEventHandler(getLink(subitem))"
                                                >
                                                    <n-link
                                                        :to="getLink(subitem)"
                                                        :class="[
                                                            {
                                                                green: subitem.green,
                                                                active: isLinkActive(getLink(subitem)),
                                                            }
                                                        ]"
                                                    >
                                                        {{ subitem.title }}
                                                        <nuxt-img
                                                            v-if="subitem.icon"
                                                            class="main-menu-submenu__icon"
                                                            :src="`icons/${subitem.icon}`"
                                                            alt="зеленый лист"
                                                            format="webp"
                                                        />
                                                    </n-link>
                                                </span>
                                                <a
                                                    v-if="!subitem.isExpanded && subitem.isExternal"
                                                    :key="subitem.path"
                                                    class="main-menu-submenu__link"
                                                    target="_self"
                                                    :href="subitem.path || '#'"
                                                >
                                                    {{ subitem.title }}
                                                </a>
                                                <button
                                                    v-if="subitem.isExpanded && !subitem.isExternal && subitem.subMenu.length"
                                                    :key="subitem.slug"
                                                    flat
                                                    :class="[
                                                        'flat-btn',
                                                        'text-left',
                                                        'main-menu-submenu__link',
                                                        'expanded-menu-item',
                                                        {
                                                            'active': activeExpandItem
                                                                && activeExpandItem.title === subitem.title,
                                                        }
                                                    ]"
                                                    @click="toggleExpandItem(subitem)"
                                                >
                                                    {{ subitem.title }}
                                                    <span class="expanded-menu-item__icon" />
                                                </button>
                                            </template>
                                        </template>
                                    </div>
                                    <!-- Expanded item -->
                                    <TheMainMenuExpandedItem />

                                    <!-- Menu banners -->
                                    <div
                                        v-if="activeChapter && activeChapter.banner"
                                        class="main-menu-submenu__col main-menu-submenu__popular"
                                    >
                                        <TneMainMenuBanner :banner-data="activeChapter.banner" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </li>
            </template>
            <li
                v-show="getOtherItems(getSubItems).length"
                class="main-menu__list-item submenu"
                @click="onMoreClickHandler"
            >
                <button
                    class="submenu__button cibButton--empty pointer"
                    :class="{
                        'opened': activeSubMenu === 'more'
                    }"
                    @click="toggleSubMenu('more')"
                >
                    <span class="main-menu__link">Еще</span>
                    <nuxt-img
                        class="cibButton__chevron"
                        src="icons/arrows/chevron-small.svg"
                        alt=""
                        format="webp"
                    />
                </button>
                <TheMainMenuOtherItems>
                    <template
                        v-if="activeChapter && activeChapter.banner"
                        #banner
                    >
                        <TneMainMenuBanner :banner-data="activeChapter.banner" />
                    </template>
                </TheMainMenuOtherItems>
            </li>
        </ul>
    </nav>
</template>

<script>
import {defineComponent, watch} from 'vue';
import {useRoute} from '@nuxtjs/composition-api';

import {useMainMenu} from '@/core/composables/useMainMenu';

import scroll from '@/core/directives/scroll';
import TneMainMenuBanner from '@/components/Navigation/MainMenuComponents/TneMainMenuBanner.vue';
import TheMainMenuExpandedItem from '@/components/Navigation/MainMenuComponents/TheMainMenuExpandedItem.vue';
import TheMainMenuOtherItems from '@/components/Navigation/MainMenuComponents/TheMainMenuOtherItems.vue';

export default defineComponent({
    directives: {
        scroll,
    },
    components: {
        TneMainMenuBanner,
        TheMainMenuExpandedItem,
        TheMainMenuOtherItems,
    },
    setup() {
        const route = useRoute();
        const menuComposable = useMainMenu();

        function isCurrentRoutePath(slug) {
            return route.value.path.split('/')?.includes(slug) ?? false;
        }

        function closeOnScroll() {
            if (menuComposable.activeSubMenu.value) {
                setTimeout(() => {
                    menuComposable.toggleSubMenu();
                }, 50);
            }
        }

        function onLinkClickHandler(event, item) {
            if (!item.isExternal) {
                // TODO: refactor this or menu structure
                if (!item.slug) {
                    return;
                }
                event.preventDefault();
                menuComposable.toggleSubMenu(item.slug);
            }
        }

        function onMoreClickHandler() {
            const activeChapter = menuComposable.menu.value.find((item) => {
                if (route.value.name === 'index') {
                    return item.slug === 'for-individuals';
                }

                return route.value.name?.includes(item.slug) ?? false;
            });

            activeChapter && menuComposable.setActiveChapter(activeChapter);
        }

        watch(() => route.value.path, (n) => {
            menuComposable.toggleSubMenu();
        });

        return {
            isCurrentRoutePath,
            closeOnScroll,
            onLinkClickHandler,
            onMoreClickHandler,
            menu: menuComposable.menu,
            activeChapter: menuComposable.activeChapter,
            activeSubMenu: menuComposable.activeSubMenu,
            activeExpandItem: menuComposable.activeExpandItem,
            setActiveChapter: menuComposable.setActiveChapter,
            toggleSubMenu: menuComposable.toggleSubMenu,
            toggleExpandItem: menuComposable.toggleExpandItem,
            getSubItems: menuComposable.getSubItems,
            getLink: menuComposable.getLink,
            isLinkActive: menuComposable.isLinkActive,
            sameLinkEventHandler: menuComposable.sameLinkEventHandler,
            getMainItems: menuComposable.getMainItems,
            getOtherItems: menuComposable.getOtherItems,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/ui-elements/cibButton';
@import '@/assets/styles/components/navigation/mainMenu';
</style>
